import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import { Route, Redirect } from "react-router-dom";

const useStyles = makeStyles(theme => ({
    root: {
        width: "80vw",
        height: "80vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        flexGrow: 1,
    },
}));

const UnauthPage = () => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <h1>401 </h1>
            <h3>Not Authorized</h3>
        </div>
    );
};

export default UnauthPage;
